import React from "react";
import { ChartCaregories } from "../../charts/categories/components/ChartCategories";
import { Templates } from "../../templates/components/Templates";

export default function ChartChooserMain() {
    return (
        <main className="chart-chooser-main p-6 w-full">
            <p className="text-xs pb-2 mb-4 border-b border-gray-300">
                Zebra BI Charts for Office enables you to visualize your data with many different chart types. Select the desired chart type
                from the list of icons. Your chart will be auto-generated and you will be able to change the data.
            </p>
            <ChartCaregories />
            {/*<Templates />*/}
        </main>
    );
}
